import { z } from "zod";
import { SelectOption, SelectOptionWithIcon } from "../../../../../schemas";

const REQUIRED_MESSAGE = "Важно! Все поля являются обязательными для заполнения";

export const FirstFormSchema = z
  .object({
    city: z.any().optional().nullable(),
    cityPoint: z.any().optional().nullable(),
    app: SelectOptionWithIcon,
    agree: z.literal(true),
  })
  .superRefine((data, ctx) => {
    const cityResult = SelectOption.safeParse(data.city);
    if (!cityResult.success) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: REQUIRED_MESSAGE,
        path: ["city"],
      });
    }

    const cityPointResult = SelectOption.safeParse(data.cityPoint);
    if (!cityPointResult.success) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: REQUIRED_MESSAGE,
        path: ["cityPoint"],
      });
    }
  });
